import { Base } from './base';

export class CellAqua extends Base {
	constructor() {
		super();

		this.type = '';

		this.MIDId = this.uuid;						// ID Identificador único (AUID) 22 0 False True False Ninguna Identificador
		this.MIDIdMatriz = '';						// IDMATRIZ Carácter 22 0 True False False Ninguna Identificador
		this.MIDFila = 0;							// FILA Numérico 10 0 False False False Ninguna Fila
		this.MIDColumna = 0;						// COLUMNA Numérico 10 0 False False False Ninguna Columna
		this.MIDLargo = 0;							// LARGO Numérico 10 2 False False False Ninguna Largo
		this.MIDAncho = 0;							// ANCHO Numérico 10 2 False False False Ninguna Ancho
		this.MIDTipo = '';							// TIPO Carácter 5 0 False False False Ninguna Tipo
		this.MIDArriba = false;						// ARRIBA Lógico 1 0 False False False Ninguna Colindante por arriba
		this.MIDAbajo = false;						// ABAJO Lógico 1 0 False False False Ninguna Colindante por abajo
		this.MIDIzquierda = false;					// IZQUIERDA Lógico 1 0 False False False Ninguna Colindante por la izquierda
		this.MIDDerecha = false;					// DERECHA Lógico 1 0 False False False Ninguna Colindante por la derecha
		this.MIDEsquiNOROEST = false;				// ESQUINANOROESTE Lógico 1 0 False False False Ninguna Esquina Nor Oeste
		this.MIDEsquinNorEST = false;				// ESQUINORESTE Lógico 1 0 False False False Ninguna Esquina NorEste
		this.MIDEsquiSurOest = false;				// ESQUINASUROESTE Lógico 1 0 False False False Ninguna Esquina SurOeste?
		this.MIDEsquiSurEste = false;				// ESQUINASURESTE Lógico 1 0 False False False Ninguna Esquina SurEste?
		this.MIDDobEsqNorte = false;				// MIDDOBLEESQNORT Lógico 1 0 False False False Ninguna Doble Esquina Norte
		this.MIDDobEsqSur = false;					// MIDDOBLEESQSUR Lógico 1 0 False False False Ninguna Doble esquina en el sur
		this.MIDDobEsqEste = false;					// MIDDOBLEESQESTE Lógico 1 0 False False False Ninguna Doble Esquina en el Este
		this.MIDDobEsqOeste = false;				// MIDDOBLEESQOEST Lógico 1 0 False False False Ninguna Doble esquina en el oeste
	
		// APP equivalent cell
		this.cell = null;
	}
}